export const developmentCookieDomain = "localhost";
export const jgntCookieDomain = ".jgnt.co";
export const juggernautCookieDomain = ".thejuggernaut.com";
